<template>
  <el-container id="timingTjcf">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background:#FFFFFF;padding:15px">
        <div style="display:flex;height:36px;width:100%;line-height:0.3;text-align:left;align-items: center;">
          <span style="margin-left:0.5vw; color: #ffffff; font-size: 13px">
            <el-input
                placeholder="输入条件名称查询"
                style="width:10vw;"
                prefix-icon="el-icon-search"
                clearable
                v-model="scan_name">
            </el-input>
          </span>
          <el-button @click="addTiming" size="small" type="primary" icon="el-icon-plus"
                     style="margin-left:auto;margin-right:15px">
            新增时段
          </el-button>
        </div>
        <el-table :data=fil_tabData class="tab_adb" :cell-style="tableYs"
                  style="width:100%; font-size:13px; background:#FFFFFF;margin-top:10px"
                  :max-height=maxHeight show-overflow-tooltip
                  :header-cell-style="{'height':'30px','text-align':'center','background':'#F4F4F4','color':'#0dA7C8'}">
          <el-table-column width="01" sortable/>
          <div v-for="(d,item) in this.defHead">
            <el-table-column :key=item :prop=d.val :label=d.key :width="d.w" sortable>
            </el-table-column>
          </div>
          <el-table-column
              label="操作"
              width="200">
            <template slot-scope="scope">
              <el-button @click="change_dvc(scope.row)" type="text" size="small" icon="el-icon-edit"
                         style="color:#72767b;font-size: 16px"/>
              <el-button @click="del_Timer(scope.row)" type="text" size="small" icon="el-icon-delete"
                         style="color:#72767b;font-size: 16px"/>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="float:right; margin-right:0.5vw;margin-top:5px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange1"
            :current-page="page"
            :page-sizes="[10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </el-main>
    </el-container>
    <el-dialog
        title="删除提示"
        :visible.sync="daidelTimer"
        width="30%">
      <span>确定删除该条件吗？ 删除后将无法找回，请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daidelTimer = false">取 消</el-button>
        <el-button type="primary" @click=delTimer()>确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  name:"timingTjcf",
  data() {
    return {
      paths:"/home/timing/ble",
      h_text:"约束时段",
      li_h_text:[
        {"text":"联动策略","colour":"#B7B7B7","pages":""}
      ],
      edi_pwr:[],
      li_pwr:[
        {
          value:'打开',
          label:'打开'
        },
        {
          value:'关闭',
          label:'关闭'
        }
      ], /*角色列表*/
      li_autoTrigger:[],
      scan_name:"",
      page:1,
      pageSize:20,
      total:0,
      maxHeight:window.innerHeight - 225,
      defHead:[
        {'key':"序号",'val':"item","w":"200px"},
        {'key':"约束条件名称",'val':"name","w":"auto"},
        {'key':"内容",'val':"content","w":"auto"}
      ],
      tabData:[],
      edi_zq:"",
      post_head:{},
      daidelTimer:false
    };
  },
  methods:{ /*方法存放*/
    handleSelectMenu(path) { /*左侧导航栏事件*/
      console.log(path);
      this.paths = path;
      this.getTiming();
    },
    change_dvc(row) {
      this.$router.push({ /*路由跳转传值*/
        path:'/home/tlinkTjtimeSon',
        query:{
          key:'change',
          id:row.id,
          name:row.name,
          fromTime:row.fromTime,
          toTime:row.toTime
        }
      });
    },
    addTiming() {
      this.$router.push({ /*路由跳转传值*/
        path:'/home/tlinkTjtimeSon',
        query:{key:'add'}
      });
    },
    del_Timer(row) {
      this.id = row.id;
      this.daidelTimer = true;
    },
    delTimer() {
      const params = {
        'id':this.id,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.delAutoException,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("删除成功");
        this.daidelTimer = false;
        this.getTiming();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("删除失败");
        }
      });
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTiming();
    },
    handleCurrentChange1(val) {
      this.page = val;
      this.getTiming();
    },
    pad(num) {
      return num.toString().padStart(2,'0');
    },
    getToTime(secs) {
      let hours = Math.floor(secs / (60 * 60));
      let divisor_for_minutes = secs % (60 * 60);
      let minutes = Math.floor(divisor_for_minutes / 60);
      let divisor_for_seconds = divisor_for_minutes % 60;
      let seconds = Math.floor(divisor_for_seconds);
      let hoursString = hours < 10 ? "0" + hours:hours.toString();
      let minutesString = minutes < 10 ? "0" + minutes:minutes.toString();
      let secondsString = seconds < 10 ? "0" + seconds:seconds.toString();
      return hoursString + ":" + minutesString + ":" + secondsString;
    },
    init_View() {
      let data = this.li_autoTrigger;
      let li_d = [];
      let j = 1;
      for (let i = 0; i < data.length; i++) {
        let d = {
          item:j,
          id:data[i]['id'],
          name:data[i]['name'],
          fromTime:data[i]['fromTime'],
          toTime:data[i]['toTime'],
          content:this.getToTime(data[i]['fromTime']) + "-" + this.getToTime(data[i]['toTime'])
        };
        li_d.push(d);
        j += 1;
      }
      this.tabData = li_d;
    },
    getTiming() {
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getAutoExceptionList,params,headers).then(res => {
        console.log(res.data.data);
        this.li_autoTrigger = res.data.data["list"];
        this.total = res.data.data.total;
        this.init_View();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取约束条件失败");
        }
      });
    }
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    this.getTiming();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData() {
      return this.tabData.filter(item => {
        this.state = true;
        if (this.scan_name && !item.name.includes(this.scan_name)) {
          this.state = false;
        }
        return this.state;
      });
    }
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#timingTjcf {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #FFFFFF;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

/*.el-switch .el-switch__label--left {
  color: #FFFFFF; !* 设置左侧标签背景色 *!
}

.el-switch .el-switch__label--right {
  color: #72767b; !* 设置右侧标签背景色 *!
}*/

::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

::-webkit-scrollbar-thumb {
  border-radius: 10px; /* 滚动条圆角 */
  background-color: #0dA7C8; /* 滚动条颜色 */
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}

</style>



// WEBPACK FOOTER //
// src/pages/scene/tlinkTjtime.vue